export default __webpack_public_path__ + "static/media/icon-13.e95d9a6e.png";